import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { ContactsPhone, ContactsSocialLinkList } from '#advertDetail/components';
import { useAdvertDetailContext } from '#advertDetail/hooks';
import advertDetailCss from '../../assets/advert-detail.module.scss';
import advertDetailContactsCss from '../../assets/contacts/contacts.module.scss';
import { useBaseContext } from '#base/hooks';

const Contacts: FC = () => {
  const { isBot } = useBaseContext();
  const {
    advert: {
      contactData,
      isDeleted,
    },
  } = useAdvertDetailContext();

  if (!isBot && isDeleted) {
    return null;
  }

  if (!contactData || contactData.isEmpty) {
    return null;
  }

  return (
    <div className={classNames(advertDetailCss.advertDetail__contacts, advertDetailContactsCss.advertDetailContacts)}>
      <div className={advertDetailContactsCss.advertDetailContacts__header}>
        <FormattedMessage defaultMessage="Fast contacts:" />
      </div>
      <ContactsPhone />
      <ContactsSocialLinkList />
    </div>
  );
};

export { Contacts };
